module.exports = __webpack_public_path__ + "img/胡勇.7420a17e.jpg";